import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useCallback } from 'react';
import { defaultFilters as defaultFiltersContacts } from '../../../components/organisms/contactsFilters/defaultFilters';
import useContactsFilterCount from '../../../hooks/useContactsFilterCount';
import { activeNetworkSelector } from '../../../redux/selectors';
import { useGetContactsQuery } from '../../../services/sharedCompanyListV2';
import { useContactsSearchParam } from '../../contactsExtended/hooks/useContactsSearchParam';

export const useFetchCompanies = ({ defaultSort = {}, defaultFilters = defaultFiltersContacts }) => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const { listId } = useParams();
  const [queryParams, setQueryParams] = useContactsSearchParam(
    {
      filters: defaultFilters,
    },
    defaultSort,
  );
  const { data, isLoading, isFetching } = useGetContactsQuery(
    {
      ...queryParams,
      networkId: activeNetwork.id,
      sharedListId: listId,
      sharedListIds: [listId],
      perPage: 10,
      maxContactsPerOrganization: 5,
    },
    { refetchOnMountOrArgChange: true },
  );
  const filtersCount = useContactsFilterCount(queryParams.filters);

  const onSetFilters = useCallback(
    (newFilters) => {
      setQueryParams({ ...queryParams, filters: newFilters, page: 1 });
      window.scrollTo(0, 0);
    },
    [queryParams, setQueryParams],
  );

  return {
    data,
    isLoading,
    isFetching,
    activeNetwork,
    listId,
    queryParams,
    setQueryParams,
    filtersCount,
    onSetFilters,
  };
};
